import { z } from 'zod';
import { imageDisclaimer } from './imageDisclaimerSchema';
import { poweredByDisclaimer } from './poweredByDisclaimerSchema';

export const IDisclaimerSchema = z.union([poweredByDisclaimer, imageDisclaimer]);

export type IDisclaimer = z.infer<typeof IDisclaimerSchema>;
